import { z } from "zod";
import { vector3dSchema } from "./primitivesSchema";

const apiPlacementSchema = z.object({
    location: vector3dSchema,
    refDirection: vector3dSchema,
    axis: vector3dSchema,
  });

export default apiPlacementSchema;